import toast from "react-hot-toast";
import { Button } from "@/components/base/shadcn/button";
import { LocalStorage } from "@/helpers/local-storage";
import { clsxMerge } from "shared/lib/helpers/styles";
import { LOG_CATEGORIES } from "@/constants/logs";
import { dd } from "@/helpers/datadog";
import { APP_VERSION } from "@/constants/version";

export const showVersionControlToast = (newVersion: string) => {
  const handleRefresh = () => {
    const LS = new LocalStorage();

    LS.appVersionLastReloadAt = new Date().toISOString();

    toast.dismiss();

    const message = `${LOG_CATEGORIES.VERSION} user triggered reload page v${APP_VERSION} -> v${newVersion}`;
    const logData = {
      data: {
        oldVersion: APP_VERSION,
        newVersion: newVersion,
      },
    };
    dd.log(message, logData);
    dd.rum.log(message, logData);

    window.location.reload();
  };

  toast.custom(
    (t) => (
      <div
        className={clsxMerge(
          "pointer-events-auto flex rounded-lg",
          "shadow-lg ring-1 ring-black ring-opacity-5",
          "w-full max-w-[360px] p-4",
          "app-gradient text-white",
          {
            "animate-fadein": t.visible,
            "animate-leave": !t.visible,
          }
        )}
      >
        <span className="flex w-full items-center justify-between gap-2">
          <span className="flex flex-col gap-1 typography-body-4">
            <span>A new app version is available!</span>
            <span>Please refresh the page!</span>
          </span>
          <Button onClick={handleRefresh}>Refresh</Button>
        </span>
      </div>
    ),
    {
      duration: 30000,
    }
  );
};
